import PropTypes from 'prop-types';
import React from 'react';
import styles from './style.css';

const SidebarFooter = props => {
  const { onKnowledgeCenterLinkClick } = props;

  return (
    <div className="footer-sidebar">
      <div className="knowledge-center">
        <span className="glyphicon glyphicon-info-sign" />
        <a
          href="https://mokaposhelp.zendesk.com/hc/en-us"
          target="_blank"
          onClick={onKnowledgeCenterLinkClick}
        >
          Knowledge Center
        </a>
      </div>
      <div className="clear" />
      <div className="phone">
        <span className="fa fa-phone-square" />
        <span className={`${styles['footer-phone-number']}`}>1500970</span>
      </div>
    </div>
  );
};

SidebarFooter.propTypes = {
  onKnowledgeCenterLinkClick: PropTypes.func,
};

SidebarFooter.defaultProps = {
  onKnowledgeCenterLinkClick: () => {},
};

export default SidebarFooter;
